div.displayedPaper {
	min-width: 110px;
	border-radius: 7px;
	border: 0.4px solid #d0d0d0;
	box-shadow: 0 0.5px 5px 0 #0000001f;
	overflow: visible;
}

div.displayedPaper::before {
	content: "";
	position: absolute;
	width: 16px;
	height: 16px;
	background-color: white;
	border: 0.4px solid #d0d0d0;
	box-shadow: 0 0.5px 5px 0 #0000001f;
	clip-path: polygon(0 0, 80% 0, 60% 60%, 0 80%);
}

ul.menuList {
	padding: 6px 0;
}

li.menuItem:global(.Mui-disabled) {
	opacity: 1;
	color: #757575;
	pointer-events: all;
	cursor: not-allowed;
}

.userMenuItemIcon {
	margin-right: 10px;

	& svg {
		width: 24px;
		height: 24px;
		color: #6f6f6f;
	}
}
